export default function (choice) {
  if (choice === true || choice === "Yes") return "Yes";
  if (choice === false || choice === "No") return "No";

  return "Empty";
}
